import React, {useState, useEffect} from 'react';
import useHttp from '../../../hook/use-http';
import { API_URL_MAIN } from '../../../constants/driveglobalfilterinitalstates_bus';
import './PdfPage.css'

export default function PdfForteenPdf(props) {

    const { isLoading, error, sendReq: fetchData } = useHttp();
    let { title, template_id, show, soarting, gloablfilter, IND } = props;

    const [refreshDate, setRefreshDate] = useState("");
    const [packWiseAData, setPackWiseAData] = useState([]);
    const [packWiseBData, setPackWiseBData] = useState([]);

    useEffect(() => {
        fetchData({ url: API_URL_MAIN + "energy_analysis_bus/energy_analysis_refreshdate_bus", body: {} }, refreshDateData)
        fetchData({ url: API_URL_MAIN + 'pdf_bus/packwisetemp', body: { filterdata: gloablfilter, pack: "A" } }, appyDataA)
        fetchData({ url: API_URL_MAIN + 'pdf_bus/packwisetemp', body: { filterdata: gloablfilter, pack: "B" } }, appyDataB)
    }, [gloablfilter])
    
    const refreshDateData = (data) => {
      setRefreshDate(data.value_as_string);
    }

    const appyDataA = (data) => {
        setPackWiseAData(data)
    }
    const appyDataB = (data) => {
        setPackWiseBData(data)
    }

  return (
    <div className='forteenpage'>
        <div className="row" style={{justifyContent:"end"}}>
            <img src='../../../assets/img_Bus/Pdf_Page/Tatamotors.png' alt='' style={{height:"80px", width:"250px"}}/>
        </div>
        <div className='row mt-4' style={{color:"black", paddingLeft:"60px", fontSize:"16px"}}>Pack wise max temperature vehicles (during Charging) (&#8805; 44 °C).</div>

        <div className='row mt-4'>

          <div className='col-md-6' style={{paddingLeft:"60px", paddingRight:"30px"}}>
              {/* <span>Top 10 Vehicle</span> */}
              <div className="text-center" style={{ borderRadius:"5px", border: "1px solid black", backgroundColor:"#83A4CF", color:"#fff", fontWeight:"bold",height:"35px", display:"flex", alignItems:"center", justifyContent:"center"}}>Pack A</div>
              <table className='table pdftable'>
                <thead>
                  <tr>
                    <th>Vin</th>
                    <th>Reg. No</th>
                    <th>City</th>
                    <th>Depot</th>
                    <th>Value</th>
                  </tr>
                </thead>
                <tbody>
                  {(packWiseAData.length > 0) &&
                  packWiseAData.map((item, index) => (
                    <tr key={index}>
                      <td>{item.key.vehicleId}</td>
                      <td>{item.key.vehicle_registration_number}</td>
                      <td>{item.key.DLR_ORG_CITY}</td>
                      <td>{item.key.Depot_Name}</td>
                      <td>{item.A_Max_Cell_Temp.value}</td>
                    </tr>
                  ))}
                </tbody>
            </table>
          </div>

            <div className='col-md-6' style={{paddingLeft:"0px", paddingRight:"100px"}}>
              <div className="text-center" style={{width:"400px", borderRadius:"5px", border: "1px solid black",  backgroundColor:"#83A4CF", color:"#fff", fontWeight:"bold",height:"35px", display:"flex",  alignItems:"center", justifyContent:"center"}}>Pack B</div>
                <table className='table pdftable'>
                    <thead>
                      <tr>
                        <th>Vin</th>
                        <th>Reg. No</th>
                        <th>City</th>
                        <th>Depot</th>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(packWiseBData.length > 0) &&
                      packWiseBData.map((item, index) => (
                        <tr key={index}>
                          <td>{item.key.vehicleId}</td>
                          <td>{item.key.vehicle_registration_number}</td>
                          <td>{item.key.DLR_ORG_CITY}</td>
                          <td>{item.key.Depot_Name}</td>
                          <td>{item.B_Max_Cell_Temp.value}</td>
                        </tr>
                      ))}
                    </tbody>
                </table>
            </div>

        </div>

        <div className='row mt-4' style={{color:"black", paddingLeft:"60px", fontSize:"16px"}}>The vehicles with maximum occurrences of current imbalance mentioned above can be investigated.</div>

        <div className='row sixthbottomcontent pl-4' style={{paddingTop:"245px"}}>
          <div className='col-md-3'>
            <img src='../../../assets/img_Bus/Pdf_Page/footer.png' alt='' style={{height:"70px", width:"200px"}}/>
          </div>
          <div className='col-md-1'></div>
          <div className='col-md-4'>
            <p style={{fontSize:"11px", paddingTop:"60px", paddingLeft:"10px"}}>Copyright, Confidential, Tata Motors Limited</p>
          </div>
        </div>
    </div>
  )
}
